<template>
  <layout-card-wrap style="margin-top:15px"
    hasHeaderSlot
    v-loading="loading">
    <template slot="title">关联批次
      <el-button type="primary"
        v-if="editable"
        :disabled="len === 0 && tradeType === 1"
        style="margin-left: 10px"
        @click="associate">关联</el-button>
    </template>
    <el-table border
      :data="inspect.batchs">
      <el-table-column label="商品批次号"
        prop="batchCode">
      </el-table-column>
      <el-table-column label="商品名称"
        prop="productName">
      </el-table-column>
      <el-table-column label="商品数量"
        prop="goodsCount">
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column>
    </el-table>
    <associate-batch-modal ref="modal"
      :selected="inspect.batchs"
      @update:selection="handleSelectionChange"
      :option="{tradeType: tradeType, vendorId: vendorId, productIds: productIds}" />
  </layout-card-wrap>
</template>

<script>
import AssociateBatchModal from './associate-batch-modal.vue'
export default {
  name: 'associate-batch',
  components: { AssociateBatchModal },
  props: {
    loading: [Boolean],
    editable: {
      type: Boolean,
      default: true
    },
    tradeType: [Number, String],
    vendorId: [Number, String],
    value: {
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    inspect: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    len () {
      return this.inspect.inspectReportDetails ? this.inspect.inspectReportDetails.length : 0
    },
    productIds () {
      return (this.inspect.inspectReportDetails || []).map(i => i.productId)
    }
  },
  watch: {
    len (val) {
      let detail = this.inspect.inspectReportDetails.map(i => i.productId)
      let ret = this.inspect.batchs.filter(i => detail.indexOf(i.productId) === -1)
      let ret1 = this.inspect.batchs.filter(i => detail.indexOf(i.productId) > -1)
      this.inspect.batchs = ret1
      this.$refs.modal.reset(ret)
    }
  },
  methods: {
    associate () {
      this.$refs.modal.toggleModal(true)
    },
    handleSelectionChange (rows) {
      this.inspect.batchs = rows
    },
    getIds () {
      return this.inspect.batchs.map(item => item.batchId)
    }
  }
}
</script>
